import React from 'react';
import { useNavigate } from 'react-router-dom';

const OutofInternetCard = ({ data, pmsitem }) => {
  const navigate = useNavigate();

  const handleRedirect = (e) => {
    e.preventDefault();
    navigate(`/offer-detail/${data?.offerid}`, {
      state: { psmItem: pmsitem },
    });
  };

  return (
    <a className="card_style_1 height_100" href="#" onClick={handleRedirect}>
      <div className="card_img">
        <img
          src={
            data.imageurl ||
            process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'
          }
          alt=""
          title=""
        />
      </div>
      <div className="card_info text-center">
        <div className="card_info_grp">
          <h4 className="text-ellipsis">{data?.title}</h4>
          <p></p>
        </div>
        <div className="card_link">
          <a href="#" className="hyperlink">
            {data?.currency + ' ' + data?.offerbaseprice}
            <img
              src={
                process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
              }
              alt=""
              title=""
            />
          </a>
        </div>
      </div>
    </a>
  );
};

export default OutofInternetCard;
